import { assign, setup } from 'xstate';

// ─── Model ───────────────────────────────────────────────────────────────────

const model = setup({
  types: {
    context: {} as Context,
    events: {} as Event,
  },
});

// ─── Machine ─────────────────────────────────────────────────────────────────

export const floatingNoticeMachine = model.createMachine({
  context: {
    dismissedNoticeText: undefined,
  },
  on: {
    DISMISS: {
      actions: assign({ dismissedNoticeText: ({ event }) => event.noticeText }),
    },
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Context = {
  dismissedNoticeText: string | undefined;
};

type Event = {
  type: 'DISMISS';
  noticeText: string;
};
